export default function () {
  return {
    pendingFetches: 0,
    hasFetched: false,
  };
}
